import { NotFoundPage } from "@redotech/redo-web/login/not-found-page";
import { isNotFoundRouteError } from "@redotech/redo-web/login/not-found-route-error";
import { memo } from "react";
import { useLocation, useRouteError } from "react-router-dom";
import { RouteStateMarker } from "./route-state-marker";

export const MerchantApp404Page = memo(function MerchantApp404Page() {
  const location = useLocation();
  const error = useRouteError();
  const isNotFoundError = isNotFoundRouteError(error);

  return (
    <>
      <RouteStateMarker
        path={location.pathname}
        state={isNotFoundError ? "not-found" : "error"}
      />
      <NotFoundPage />
    </>
  );
});
